interface ITextParagraph {
  content: ITextContent[];
}

interface ITextContent {
  text: string;
  bold?: boolean;
  italic?: boolean;
  code?: boolean;
  link?: string;
}

export function parseMarkdownToTextParagraphs(markdown: string): ITextParagraph[] {
  const lines = markdown.split(/\n|\\n/);
  const paragraphs: ITextParagraph[] = [];

  lines.forEach((line) => {
    const content: ITextContent[] = [];
    let remainingText = line;

    // 正则表达式匹配完整的markdown语法
    const regex = /(\*\*(.*?)\*\*|__(.*?)__|`(.*?)`|\[(.*?)\]\((.*?)\)|\*(.*?)\*|_(.*?)_)/;
    let match;

    while ((match = remainingText.match(regex))) {
      const [fullMatch, , boldStar, boldUnderscore, code, linkText, linkUrl, italicStar, italicUnderscore] = match;
      const index = match.index || 0;

      // 添加匹配前的普通文本
      if (index > 0) {
        content.push({ text: remainingText.slice(0, index) });
      }

      // 根据匹配的类型添加格式化文本
      if (boldStar !== undefined || boldUnderscore !== undefined) {
        // 粗体文本
        const boldText = boldStar !== undefined ? boldStar : boldUnderscore;
        content.push({ text: boldText, bold: true });
      } else if (code !== undefined) {
        // 代码文本
        content.push({ text: code, code: true });
      } else if (linkText !== undefined && linkUrl !== undefined) {
        // 链接文本
        content.push({ text: linkText, link: linkUrl });
      } else if (italicStar !== undefined || italicUnderscore !== undefined) {
        // 斜体文本
        const italicText = italicStar !== undefined ? italicStar : italicUnderscore;
        content.push({ text: italicText, italic: true });
      }

      // 移除已处理的部分
      remainingText = remainingText.slice(index + fullMatch.length);
    }

    // 添加剩余的普通文本
    if (remainingText) {
      content.push({ text: remainingText });
    }

    paragraphs.push({ content });
  });

  return paragraphs;
}
